import { render, staticRenderFns } from "./EmojiList.vue?vue&type=template&id=4d42ee49"
import script from "./EmojiList.vue?vue&type=script&lang=js"
export * from "./EmojiList.vue?vue&type=script&lang=js"
import style0 from "./EmojiList.vue?vue&type=style&index=0&id=4d42ee49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports